import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class BudgetDetail  {
    _originalTypeClassName = "zERP.BO.BudgetDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
BudgetDetail.translate = translateService;
}
this.BudgetItem = new Domain.BudgetItem();
this.Adjustments = [];
this.SpendingRequests = [];
this.Id = null;
this.Code = null;
this.Description = null;
this.InitialAmount = null;
this.TemporaryAmount = null;
this.InitialApprovedAmount = null;
this.AmountLastYear = null;
this.Amount2YearBefore = null;
this.IsExpense = false;
this.IncomeApprovedAmount = null;
this.IncomeReceiptApprovedAmount = null;
this.ReceivedAmount = null;
this.IncomeSettledAmount = null;
this.CategoryId = null;
this.BudgetId = null;
this.BudgetStatus = null;
this.PredictedBalance = null;
this.AdjustmentsAmount = null;
this.TotalBudgetAmount = null;
this.ReservedAmount = null;
this.RemainingBudgetAmount = null;
this.InvoicedAmount = null;
this.RemainingReservedAmount = null;
this.PaymentOrderedAmount = null;
this.RemainingInvoicedAmount = null;
this.PaidAmount = null;
this.RemainingPaymentOrderdAmount = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Description:any;
InitialAmount:any;
TemporaryAmount:any;
InitialApprovedAmount:any;
AmountLastYear:any;
Amount2YearBefore:any;
IsExpense:any;
IncomeApprovedAmount:any;
IncomeReceiptApprovedAmount:any;
ReceivedAmount:any;
IncomeSettledAmount:any;
CategoryId:any;
BudgetId:any;
BudgetStatus:any;
PredictedBalance:any;
AdjustmentsAmount:any;
TotalBudgetAmount:any;
ReservedAmount:any;
RemainingBudgetAmount:any;
InvoicedAmount:any;
RemainingReservedAmount:any;
PaymentOrderedAmount:any;
RemainingInvoicedAmount:any;
PaidAmount:any;
RemainingPaymentOrderdAmount:any;
BudgetItem:any;
Adjustments:any;
SpendingRequests:any;
static setBudgetItem = ($this, value) => {
var oldValue = $this.BudgetItem;
$this.BudgetItem = value;
if (value != null) {
}
}
static setAdjustments = ($this, items) => {
                if (items == null) items = [];
                if ($this.Adjustments == null) $this.Adjustments = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Adjustments.length > 0) {
                    Domain.BudgetDetail.removeAdjustments($this, $this.Adjustments[0]);
                }

                Domain.BudgetDetail.addManyAdjustments($this, copyItems);
            }
static addManyAdjustments = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BudgetDetail.addAdjustments($this, items[i]);
                }
            }
static addAdjustments = ($this, item) => {
                if ($this.Adjustments == null) $this.Adjustments = [];
                if (item == null || $this.Adjustments.indexOf(item) > -1) return;
                $this.Adjustments.push(item);
if (item.BudgetDetail != $this) {
Domain.BudgetAdjustmentDetail.setBudgetDetail(item, $this);
}
}
static addRangeAdjustments = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BudgetDetail.addAdjustments($this, item));
            }
static removeAdjustments = ($this, item) => {
                if ($this == null || $this.Adjustments == null || $this.Adjustments.indexOf(item) === -1) return;
                var _index = $this.Adjustments.indexOf(item);
                $this.Adjustments.splice(_index, 1);
item.BudgetDetail = null;
}
static clearAdjustments = ($this) => { $this.Adjustments = null; }
static setSpendingRequests = ($this, items) => {
                if (items == null) items = [];
                if ($this.SpendingRequests == null) $this.SpendingRequests = [];

                const copyItems = Common.cloneObject(items);

                while ($this.SpendingRequests.length > 0) {
                    Domain.BudgetDetail.removeSpendingRequests($this, $this.SpendingRequests[0]);
                }

                Domain.BudgetDetail.addManySpendingRequests($this, copyItems);
            }
static addManySpendingRequests = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.BudgetDetail.addSpendingRequests($this, items[i]);
                }
            }
static addSpendingRequests = ($this, item) => {
                if ($this.SpendingRequests == null) $this.SpendingRequests = [];
                if (item == null || $this.SpendingRequests.indexOf(item) > -1) return;
                $this.SpendingRequests.push(item);
if (item.Item != $this) {
Domain.SpendingRequestDetail.setItem(item, $this);
}
}
static addRangeSpendingRequests = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.BudgetDetail.addSpendingRequests($this, item));
            }
static removeSpendingRequests = ($this, item) => {
                if ($this == null || $this.SpendingRequests == null || $this.SpendingRequests.indexOf(item) === -1) return;
                var _index = $this.SpendingRequests.indexOf(item);
                $this.SpendingRequests.splice(_index, 1);
item.Item = null;
}
static clearSpendingRequests = ($this) => { $this.SpendingRequests = null; }

static GetClassName(): any{return "BudgetDetail";
}
static GetRemainingBudgetAmount($this: any): any{let totalBudgetAmount = Domain.BudgetDetail.GetTotalBudgetAmount($this);
if (CLMS.Framework.Number.Equal(() => totalBudgetAmount, () => null)) {totalBudgetAmount = 0;}
if ($this?.IsExpense) {let reservedAmount = (CLMS.Framework.Number.NotEqual(() => $this.ReservedAmount, () => null) ? $this?.ReservedAmount : 0);return Joove.Common.safeNumber(totalBudgetAmount) - Joove.Common.safeNumber(reservedAmount);}
let receivedAmount = (CLMS.Framework.Number.NotEqual(() => $this.ReceivedAmount, () => null) ? $this?.ReceivedAmount : 0);
return Joove.Common.safeNumber(totalBudgetAmount) - Joove.Common.safeNumber(receivedAmount);
}
static GetRemainingInvoicedAmount($this: any): any{let invoicedAmount = (CLMS.Framework.Number.NotEqual(() => $this.InvoicedAmount, () => null) ? $this?.InvoicedAmount : 0);
let paymentOrderedAmount = (CLMS.Framework.Number.NotEqual(() => $this.PaymentOrderedAmount, () => null) ? $this?.PaymentOrderedAmount : 0);
return Joove.Common.safeNumber(invoicedAmount) - Joove.Common.safeNumber(paymentOrderedAmount);
}
static GetRemainingPaymentOrderdAmount($this: any): any{let paymentOrderedAmount = (CLMS.Framework.Number.NotEqual(() => $this.PaymentOrderedAmount, () => null) ? $this?.PaymentOrderedAmount : 0);
let paidAmount = (CLMS.Framework.Number.NotEqual(() => $this.PaidAmount, () => null) ? $this?.PaidAmount : 0);
return Joove.Common.safeNumber(paymentOrderedAmount) - Joove.Common.safeNumber(paidAmount);
}
static GetRemainingReservedAmount($this: any): any{let reservedAmount = (CLMS.Framework.Number.NotEqual(() => $this.ReservedAmount, () => null) ? $this?.ReservedAmount : 0);
let invoicedAmount = (CLMS.Framework.Number.NotEqual(() => $this.InvoicedAmount, () => null) ? $this?.InvoicedAmount : 0);
return Joove.Common.safeNumber(reservedAmount) - Joove.Common.safeNumber(invoicedAmount);
}
static GetTotalBudgetAmount($this: any): any{if ($this?.BudgetStatus != Domain.BudgetStatus.Approved) {return $this?.TemporaryAmount;}
let initialApprovedAmount = (CLMS.Framework.Number.NotEqual(() => $this.InitialApprovedAmount, () => null) ? $this?.InitialApprovedAmount : 0);
let adjustmentsAmount = (CLMS.Framework.Number.NotEqual(() => $this.AdjustmentsAmount, () => null) ? $this?.AdjustmentsAmount : 0);
return Joove.Common.safeNumber(initialApprovedAmount) + Joove.Common.safeNumber(adjustmentsAmount);
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}